import Dashboard from "../../views/dashboard/Dashboard.vue";

const operationlog = {
  path: "/operationlog",
  name: "operationlog",
  component: Dashboard,
  meta: {
    title: "日志查询",
    icon: "el-icon-warning",
    role: false
  },
  children: [
    {
      path: "/logdetails",
      name: "logdetails",
      component: () => import("../../components/operationlog/logdetails.vue"),
      meta: {
        title: "操作日志",
        icon: "el-icon-warning",
        role: false
      }
    },
    {
      path: "/loginlogdetails",
      name: "loginlogdetails",
      component: () =>
        import("../../components/operationlog/loginlogdetails.vue"),
      meta: {
        title: "登录日志",
        icon: "el-icon-warning",
        role: false
      }
    }
    ,
    {
      path: "/logvertify",
      name: "logvertify",
      component: () =>
        import("../../components/operationlog/logvertify.vue"),
      meta: {
        title: "认证日志",
        icon: "el-icon-warning",
        role: false
      }
    }
  ]
};

export default operationlog;
